module.exports = __webpack_public_path__ + "static/img/7.dd22b41.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/zh/7.png
// module id = wOnt
// module chunks = 0